import React, { Component } from 'react';

class TrackHowTo extends Component {
    render() {
        return (
            <div>Track</div>
        );
    }
}

export default TrackHowTo;
